const { location, queryParams } = require('@wix/site-location');
const { session } = require('@wix/site-storage');

async function handleParam(paramKey, setParamInSessionMethod, additionalParams) {
  const url = await location.url();
  const parsedUrl = new URL(url);
  const paramFromUrl = parsedUrl.searchParams.get(paramKey);
  const paramFromSession = await session.getItem(paramKey);

  if (paramFromUrl && paramFromSession) {
    return;
  }

  if (!paramFromUrl && !paramFromSession) {
    return;
  }

  if (paramFromUrl && !paramFromSession) {
    await setParamInSessionMethod(paramKey, paramFromUrl);
    return;
  }

  if (!paramFromUrl && paramFromSession) {
    queryParams.queryParams().add({
      ...additionalParams,
      [paramKey]: paramFromSession,
    });

    const urlWithParams = await location.url();
    location.to(urlWithParams);
    return;
  }
}

async function setParamInSession(paramKey, paramFromUrl) {
  await session.setItem(paramKey, paramFromUrl);
  console.log(`${paramKey} saved to session storage:`, paramFromUrl);
}

module.exports = {
  handleParam,
  setParamInSession,
};
